import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { handleError } from '../shared/utils/http';
import { BehaviorSubject, catchError, filter, Observable, of, tap } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class MissionService {
  initialValue: boolean = false;
  refreshMissionSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    this.initialValue
  );

  private cachedCurrentMissionsSubject = new BehaviorSubject<any[] | null>(null);
  currentMissions$ = this.cachedCurrentMissionsSubject.asObservable();

  private previousUrl: string | null = null;
  private currentUrl: string | null = null;
  constructor(private http: HttpClient, private router: Router) {
    this.currentUrl = this.router.url;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: any) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      });
  }

  public getPreviousUrl(): string | null {
    return this.previousUrl;
  }

  toggleRefreshMission() {
    this.refreshMissionSource.next(!this.refreshMissionSource.value);
  }
  getFichePosteById(id: any) {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/fichePoste/${id}`
    );
  }
  getSites(candiatId: any) {
    return this.http.get(
      `${environment.api.BASE_URL}/api/etablissements/${candiatId}/sites`
    );
  }
  getRegions(): Observable<any> {
    return this.http.get(`${environment.api.REGIONS_URL}`);
  }
  getProfileRegions(): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/missions/regions`);
  }
  getDepartment(): Observable<any> {
    return this.http.get(`${environment.api.DEPARTMENTS_URL}`);
  }
  getRefreshMission(): Observable<boolean> {
    return this.refreshMissionSource.asObservable();
  }

  getRefMission(id: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/generateMissionRef/${id}`
    );
  }

  getAffectationBySiteId(id: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/service-affectation/sites/${id}`
    );
  }

  refuMission(missionId: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/evaluation/refus/${missionId}`
    );
  }
  getMissions(): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/missions`);
  }
  sendEval(body: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/api/missions/evaluation`,
      body
    );
  }

  rejectMission(body: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/api/missions/evaluation/rejected`,
      body
    );
  }

  get refreshMission(): boolean {
    return this.refreshMissionSource.getValue();
  }

  getMissionsSonn(
    candidatId: any,
    typePosteId: any,
    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/soon/candidat/${candidatId}/occupation/${typePosteId}/pages?offset=${offset}&size=${size}`
    );
  }

  SoumettreMission(candidatId: number, missionId: number) {
    return this.http.post(
      `${environment.api.BASE_URL}/api/candidats/missions?candidatId=${candidatId}&missionId=${missionId}`,
      {}
    );
  }

  SignerMission(candidatId: number, missionId: number, preview: number) {
    return this.http.get(
      `${environment.api.BASE_URL}/api/generate/sign-url?candidatId=${candidatId}&missionId=${missionId}&preview=${preview}`,
      { responseType: 'text' }
    );
  }
  AnnulerMission(candidatId: number, missionId: number) {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/${missionId}/cancel/${candidatId}`
    );
  }
  SupprissionMission(body: any) {
    return this.http.put(`${environment.api.BASE_URL}/api/missions/archive`, body);
  }
  cancelMission(body: any) {
    return this.http.put(
      `${environment.api.BASE_URL}/api/missions/signed/cancel`,
      body
    );
  }
  contestRejection(body: any) {
    return this.http.put(
      `${environment.api.BASE_URL}/api/missions/finished/contestRejection`,
      body
    );
  }
  getActiveMissions(
    candidatId: any,
    typePosteId: any,

    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/started/candidat/${candidatId}/occupation/${typePosteId}/pages?offset=${offset}&size=${size}`
    );
  }

  getFinishedMissions(
    candidatId: any,
    typePosteId: any,
    date: any,
    name: string,
    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.get(
      name && date
        ? `${environment.api.BASE_URL}/api/missions/candidat/${candidatId}/occupation/${typePosteId}/pages/finished?date=${date}&name=${name}&offset=${offset}&size=${size}`
        : name && !date
          ? `${environment.api.BASE_URL}/api/missions/candidat/${candidatId}/occupation/${typePosteId}/pages/finished?name=${name}&offset=${offset}&size=${size}`
          : date && !name
            ? `${environment.api.BASE_URL}/api/missions/candidat/${candidatId}/occupation/${typePosteId}/pages/finished?date=${date}&offset=${offset}&size=${size}`
            : `${environment.api.BASE_URL}/api/missions/candidat/${candidatId}/occupation/${typePosteId}/pages/finished?offset=${offset}&size=${size}`
    );
  }

  getCurrentMissions(
    candidatId: any,
    typePosteId: any,
    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/candidat/${candidatId}/occupation/${typePosteId}/pages/current?offset=${offset}&size=${size}`
    );
  }

  getLiberalCurrentMissions(version = ""): Observable<any> {
    if (this.cachedCurrentMissionsSubject.value) {
      return of(this.cachedCurrentMissionsSubject.value);
    }
    return this.http.get<any[]>(
      `${environment.api.BASE_URL}/api${version}/missions/pages/current`).pipe(
        tap((data) => {
          this.cachedCurrentMissionsSubject.next(data);
        }),
        catchError((error) => {
          console.error('Failed to fetch current liberal missions', error);
          throw error;
        })
      );;
  }

  getLiberalCurrentMissionsWithPagination(offset: number = 0, size: number = 10, search: string = '', siteId: number = 0): Observable<any> {
    let url = `${environment.api.BASE_URL}/api/v2/missions/pages/current?offset=${offset}&size=${size}`;
    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }
    if (siteId && siteId > 0) {
      url += `&siteId=${siteId}`;
    }
    return this.http.post<any>(url, {}).pipe(
      catchError(error => {
        console.error('Error fetching paginated missions:', error);
        return of({ missions: [], totalItems: 0, total: 0, offset: 0, size: size, totalPages: 0, hasNext: false, hasPrevious: false });
      })
    );
  }

  clearCache(): void {
    this.cachedCurrentMissionsSubject.next(null);
  }

  getNextConfirmedMission(
    candidatId: any
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/candidat/${candidatId}/nextConfirmed`
    );
  }

  getAcceuilMissions(
    candidatId: any,
    typePosteId: any,
    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/candidat/${candidatId}/occupation/${typePosteId}/pages?offset=${offset}&size=${size}`
    );
  }
  getAcceuilMissionWithQuerry(
    candidatId: any,
    typePosteId: any,
    startDate: any,
    endDate: any,
    offset: any = 0,
    size: any = 10
  ): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/api/missions/available/current/pages?offset=${offset}&size=${size}`,
      {
        candidateId: candidatId,
        typePostId: typePosteId,
        startDate: startDate,
        endDate: endDate,
      }
    );
  }

  getMissionsByCondidat(id: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/missions/candidat/${id}`);
  }

  getMissionsByCondidatV2(id: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/v2/missions/candidat/${id}`);
  }

  getMissionsByCondidatIdAndMissionId(
    candidatId: any,
    missionId: any
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/${missionId}/candidat/${candidatId}`
    );
  }

  getRegionByCode(id: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/regionByCode?code=${id}`
    );
  }

  getMissionsByEtablissment(id: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/etablissements/${id}`);
  }

  getPostes(idSecteur: number): Promise<any> {
    return this.http
      .get(`${environment.api.BASE_URL}/api/missions/secteurs/${idSecteur}/postes`)
      .toPromise()
      .catch(handleError);
  }

  getSecteurs(): Promise<any> {
    return this.http
      .get(`${environment.api.BASE_URL}/api/missions/secteurs`)
      .toPromise()
      .catch(handleError);
  }

  getAllPostes(): Promise<any> {
    return this.http
      .get(`${environment.api.BASE_URL}/api/missions/postes`)
      .toPromise()
      .catch(handleError);
  }

  getAffectationService(): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/service-affectation`);
  }

  addMission(body: any): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/api/missions`, body);
  }

  draftMission(body: any): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/api/missions/draft`, body);
  }

  updateDraftMission(body: any): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/api/missions/draft/${body.id}`,
      body
    );
  }
  updateDraftPublishMission(body: any): Observable<any> {
    const missionId = body.id;
    return this.http.put(
      `${environment.api.BASE_URL}/api/missions/draft/publish/${missionId}`,
      body
    );
  }

  deleteDraft(id: any): Observable<any> {
    return this.http.delete(`${environment.api.BASE_URL}/api/missions/${id}`);
  }

  missionFilter(body: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/api/missions/filter/temporal?offset=0&size=10`,
      body
    );
  }

  addGetAvailability(id: any): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/availability/${id}`);
  }

  addAvailability(id: any, body: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/api/availability/${id}`,
      body
    );
  }

  addAvailableDay(id: any, body: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/api/availability/${id}/add`,
      body
    );
  }

  getMissionsByEstablishmentId(body: any, id: number): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/api/etablissements/${id}/filter`,
      body
    );
  }

  updateCandidateStatus(body: any): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/api/candidats/decision`,
      body
    );
  }

  acceptCancelRequest(candidateId: number, missionId: number): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/api/missions/signed/${missionId}/acceptCancellation/${candidateId}`,
      {}
    );
  }

  updateMissionStatus(body: any): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/api/missions/evaluation/decision`,
      body
    );
  }

  deleteMission(missionId: number): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/api/missions/pending/cancel/${missionId}`,
      {}
    );
  }

  getMissionById(id: string, version = ""): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api${version}/missions/${id}`);
  }

  duplicateMission(id: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/duplicate/${id}`
    );
  }

  sendSignContractReminder(reminderDto: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/api/reminder/send/signContract`, reminderDto
    );
  }

  sendValidateMissionReminder(candidateId: number, reminderDto: any): Observable<any> {
    return this.http.post(
      `${environment.api.BASE_URL}/api/reminder/send/validateMission/${candidateId}`, reminderDto
    );
  }

  cancelCandidacyOnAcceptedMission(missionId: number, candidateId: number, motif: any): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/api/missions/accepted/agency/${missionId}/cancel/${candidateId}`, motif
    );
  }

  cancelCandidacyOnPendingMission(missionId: number, candidateId: number, motif: any): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/api/missions/pending/agency/${missionId}/cancel/${candidateId}`, motif
    );
  }

  cancelCandidacyOnAcceptedAndSignedMission(missionId: number, candidateId: number, motif: any): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/api/missions/signed/agency/${missionId}/cancel/${candidateId}`, motif
    );
  }

  findMotifRefus(missionId: number, candidateId: number, establishmentId: number): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/api/missions/evaluation/refus/${missionId}/${candidateId}/${establishmentId}`,
    );
  }

  cancelPendingMission(missionId: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/missions/agency/pending/cancel/${missionId}`)
  }

  getWeeklyReports(): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/imputation/weekly-reports`);
  }

  createSecteur(name: string): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/api/missions/secteurs`, { name });
  }

  createPoste(secteurId: number, name: string): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/api/missions/secteurs/${secteurId}/postes`, { name });
  }

  // ────────── Direct Assignment APIs ──────────

  getUnassignedMissions(offset: number = 0, size: number = 10, search: string = '', siteId: number = 0): Observable<any> {
    let url = `${environment.api.BASE_URL}/api/agency/missions/unassigned?offset=${offset}&size=${size}`;
    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }
    if (siteId && siteId > 0) {
      url += `&siteId=${siteId}`;
    }
    return this.http.get<any>(url).pipe(
      catchError(error => {
        console.error('Error fetching unassigned missions:', error);
        return of({ missions: [], totalItems: 0 });
      })
    );
  }

  getCandidatesByDistance(missionId: number, maxDistance: number = 50, search: string = '', offset: number = 0, size: number = 50): Observable<any> {
    let url = `${environment.api.BASE_URL}/api/agency/candidates-by-distance?missionId=${missionId}&maxDistance=${maxDistance}&offset=${offset}&size=${size}`;
    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }
    return this.http.get<any>(url).pipe(
      catchError(error => {
        console.error('Error fetching candidates by distance:', error);
        return of({ candidates: [], totalItems: 0 });
      })
    );
  }

  getCandidateAvailability(candidatId: number, missionId: number): Observable<any> {
    return this.http.get<any>(
      `${environment.api.BASE_URL}/api/agency/candidate-availability/${candidatId}?missionId=${missionId}`
    ).pipe(
      catchError(error => {
        console.error('Error fetching candidate availability:', error);
        return of({ nonAvailabilityDates: [], assignedFragmentDates: [], hasCalendarConflict: false });
      })
    );
  }

  directAssign(body: any): Observable<any> {
    return this.http.post<any>(`${environment.api.BASE_URL}/api/agency/direct-assign`, body);
  }

  previewContract(missionId: number, candidatId: number, contractType: 'MISSION' | 'DISPOSITION' = 'MISSION',  applicationId:number): Observable<any> {
    return this.http.post<any>(
      `${environment.api.BASE_URL}/api/agency/preview-contract?missionId=${missionId}&candidatId=${candidatId}&contractType=${contractType}${applicationId ? `&applicationId=${applicationId}` : ''}`,
      {}
    );
  }

  saveContractEdits(edits: any): Observable<any> {
    return this.http.put<any>(`${environment.api.BASE_URL}/api/agency/save-contract-edits`, edits);
  }

  validateSendMissionContract(missionId: number, candidatId: number, applicationId:number): Observable<any> {
    return this.http.post<any>(`${environment.api.BASE_URL}/api/agency/validate-send-mission-contract`, { missionId, candidatId, applicationId });
  }

  validateSendDispositionContract(missionId: number, candidatId: number, applicationId:number): Observable<any> {
    return this.http.post<any>(`${environment.api.BASE_URL}/api/agency/validate-send-disposition-contract`, { missionId, candidatId, applicationId });
  }

  getDispositionDocuSignUrl(missionId: number, candidatId: number, applicationId:number): Observable<string> {
    return this.http.get<string>(`${environment.api.BASE_URL}/api/agency/disposition-docusign-url?missionId=${missionId}&candidatId=${candidatId}${applicationId ? `&applicationId=${applicationId}` : ''}`);
  }

  getPendingContracts(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.api.BASE_URL}/api/agency/pending-contracts`);
  }

  getContractTrackerStatus(missionId: number, candidatId: number, applicationId: any): Observable<any> {
    return this.http.get<any>(
      `${environment.api.BASE_URL}/api/agency/contract-tracker-status?missionId=${missionId}&candidatId=${candidatId}${applicationId ? `&applicationId=${applicationId}` : ''}`
    );
  }

  setContractReminderConfig(missionId: number, applicationId:any, candidatId: number, contractType: 'MISSION' | 'DISPOSITION', enabled: boolean, intervalHours: number, nextSendInHours?: number): Observable<any> {
    return this.http.put<any>(`${environment.api.BASE_URL}/api/agency/contract-reminder-config`, { applicationId, missionId, candidatId, contractType, enabled, intervalHours, nextSendInHours });
  }

  sendContractReminderNow(missionId: number, candidatId: number, contractType: 'MISSION' | 'DISPOSITION', applicationId?: number): Observable<any> {
    return this.http.post<any>(`${environment.api.BASE_URL}/api/agency/contract-send-reminder`, { missionId, candidatId, contractType, ...(applicationId ? { applicationId } : {}) });
  }

  getContractSnapshot(missionId: number, candidatId: number, contractType: string, applicationId: number): Observable<any> {
    return this.http.get<any>(
      `${environment.api.BASE_URL}/api/agency/contract-snapshot?missionId=${missionId}&candidatId=${candidatId}&contractType=${contractType}${applicationId ? `&applicationId=${applicationId}` : ''}`
    );
  }
}
